import {useMemo} from 'react';
import {isAndroid, isIOS} from 'react-device-detect';
import type {MeshType} from 'api/generated';
import {useEditorStyle} from 'hooks';
import {Android, IOS} from 'components';

interface IEditorContentLauncherProps {
  mobileStyle?: React.CSSProperties;
  assignedMeshes: MeshType[];
}

const EditorContentLauncher = ({assignedMeshes}: IEditorContentLauncherProps) => {
  const {device, style: editorStyle} = useEditorStyle();
  const style = device === 'mobile' ? editorStyle : {...editorStyle, display: 'none'};

  const projectState = useMemo(() => {
    if (!!location.href.match(location.origin + '/preview/')) return 'preview';
    if (!!location.href.match(location.origin + '/ar/')) return 'live';
    return 'preview';
  }, []);

  const props = {
    style,
    assignedMeshes,
    projectState: projectState as typeof projectState,
  };

  if (isAndroid) return <Android {...props} />;
  if (isIOS) return <IOS {...props} />;
  return null;
};

EditorContentLauncher.craft = {
  displayName: 'Launcher',
  custom: {
    icon: 'RocketLaunchIcon',
  },
  props: {
    assignedMeshes: [],
    style: {
      color: 'white',
      fontWeight: '500',
      backgroundColor: '#34bb78',
      borderRadius: '30px',
      padding: '12px 32px 12px 32px',
      margin: '0 0 0 0',
    },
    mobileStyle: {},
  },
};

export default EditorContentLauncher;
